import { Verification } from "./Verification";
import { InterviewRequestSchema, RequestStatus, RequestType, WWCCRequestSchema } from "../../firestore/Types/RequestSchema";
import { useCallback, useEffect, useState } from "react";
import { createInterviewRequest, getInterviewRequest, getWWCCRequest } from "../../firestore/Functions/requestFunction";
import { WWCC } from "./WWCC";
import { TutorCredentialsView } from "../../firestore/Types/TutorCredentialsSchema";
import { getTutorCredentials } from "../../firestore/Functions/tutorCredentialFunctions";
import { Roles } from "../../firestore/Types/PermissionSchema";
import { useAuth } from "../../contexts/auth/AppAuthContext";
import { useUtility } from "../../contexts/auth/UtilityContext";

export function Approvals() {
    const [WWCCRequests, setWWCCRequests] = useState<WWCCRequestSchema[]>([]);
    const [InterviewRequests, setInterviewRequests] = useState<InterviewRequestSchema[]>([]);
    const [tutorCredentials, setTutorCredentials] = useState<TutorCredentialsView | undefined>(undefined);
    const [loading, setLoading] = useState(true);
    const [WWCCStatus, setWWCCStatus] = useState<RequestStatus>(RequestStatus.None);
    const [InterviewStatus, setInterviewStatus] = useState<RequestStatus>(RequestStatus.None);
    
    const { setNewToast } = useUtility();

    const { currentUser, permission } = useAuth();

    const bookInterview = async () => {
        await createInterviewRequest();
        await refreshApprovals();
    }

    const handleRefresh = useCallback( async () => {
        if (permission.Role !== Roles.Tutor) {
            return;
        }
        const credentials = await getTutorCredentials(currentUser?.uid ?? "").catch((error) => undefined);
        setTutorCredentials(credentials);
    }, [permission.Role, currentUser?.uid]);
    
        const refreshApprovals = useCallback(async () => {
            setLoading(true);
            getWWCCRequest().then((requests) => {
                setWWCCRequests(requests);
            }).catch((error) => {
                setNewToast({title: "Internal Error", message: error.message, toastType: "error"})
            });
    
            getInterviewRequest().then((requests) => {
                setInterviewRequests(requests);
            }).catch((error) => {
                setNewToast({title: "Internal Error", message: error.message, toastType: "error"})
            });
            setLoading(false);
        }
        , [setNewToast]);

    useEffect(() => {
        refreshApprovals();
    }, [refreshApprovals]);

    useEffect(() => {
        if (WWCCRequests.length > 0) {
            setWWCCStatus(WWCCRequests[0].Status);
        }
    }, [WWCCRequests]);

    useEffect(() => {
        if (InterviewRequests.length > 0) {
            setInterviewStatus(InterviewRequests[0].Status);
        }
    }, [InterviewRequests]);

    useEffect(() => {
        handleRefresh();
    }, [currentUser, handleRefresh]);

	return (
        <>
            <div className="section-box p-4 gap-4">
                {loading ? <div>Loading...</div> : 
                <>
                    <div className="text-xl flex flex-row"> 
                        <div className="flex flex-row grow">
                            <h3 className="section-title">Approvals</h3>
                        </div>
                    </div>
                    <Verification type={RequestType.WWCC} status={WWCCStatus}></Verification>
                    {InterviewStatus === RequestStatus.None ? 
                        <Verification type={RequestType.Interview} status={InterviewStatus} sendRequest={bookInterview}></Verification>
                    : <Verification type={RequestType.Interview} status={InterviewStatus}></Verification>}
                </>
                }
            </div>
            <WWCC tutorCredentials={tutorCredentials?? {} as TutorCredentialsView} refreshApprovals={refreshApprovals} handleRefresh={handleRefresh} setTutorCredentials={setTutorCredentials}/>
        </>
	);;
}